export default "__VITE_ASSET__CPYsAFoL__"